import { Grid, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import { dispatch } from "store";
import TitleService from "title-service";
import { useDispatch, useSelector } from 'react-redux';
import { get_all_approvedMedia, get_selected_approvedMedia, is_approvedMedia_busy } from "features/approvedMedia/approvedMedia-slice";
import { get_all_approvedSeries, get_selected_approvedSeries } from "features/approvedSeries/approvedSeries-slice";
import { get_all_coherentScreen, get_selected_coherentScreen, setSelectedcoherentScreen } from "features/coherentScreen/coherentScreen-slice";
import { get_all_curatedMediaList, get_selected_curatedMediaList, is_curatedMediaList_busy } from "features/curatedMediaList/curatedMediaList-slice";
import { get_all_curatedSeriesList, get_selected_curatedSeriesList, is_curatedSeriesList_busy } from "features/curatedSeriesList/curatedSeriesList-slice";
import { get_all_media, get_selected_media } from "features/media/media-slice";
import { get_all_mediaCache, get_selected_mediaCache } from "features/mediaCache/mediaCache-slice";
import { get_all_processedMedia, get_selected_processedMedia } from "features/processedMedia/processedMedia-slice";
import { get_all_releaseScheduleAction, get_selected_releaseScheduleAction } from "features/releaseScheduleAction/releaseScheduleAction-slice";
import { get_all_season, get_selected_season } from "features/season/season-slice";
import { get_all_series, get_selected_series } from "features/series/series-slice";
import * as firebaseapp from 'features/firebase-app';
import { ResolvePath, ResolveStorageUrl } from 'features/firebase-app'
import * as autoThunks from 'features/auto-thunks';
import RQ from 'components/RedQuick'
import { getUserClaims } from 'features/application/application-slice';
import { useEffect, useState } from "react";
import FlashingText from "./Flashing";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { trimDownApprovedMedia, trimDownApprovedSeries, trimDownCuratedMediaList, trimDownMedias, trimDownProcessedMedias, trimdownCuratedSeriesList } from "./CacheServices";
import { ContentCarrier, ProcessedMedia } from "models";
import { useNavigate, useParams } from 'react-router-dom'
import { getLocationPath } from "./PreviewCoherentScreenModelComponent";
import { get_all_customerSettings, get_selected_customerSettings, setSelectedcustomerSettings } from "features/customerSettings/customerSettings-slice";
import { mapAsync } from "./arrayutil";
import LinearIndeterminate from "./LinearIndeterminate";
import CircularIndeterminate from "./CircleIndeterminate";

export default function QuickLoadResourceCreateComponent() {
    const params = useParams()
    const navigate = useNavigate()
    let approvedSeries_list = useSelector(get_all_approvedSeries);
    let approvedSeries = useSelector(get_selected_approvedSeries);
    let approvedMedia_list = useSelector(get_all_approvedMedia);
    let approvedMedia = useSelector(get_selected_approvedMedia);
    let processedMedia_list = useSelector(get_all_processedMedia);
    let processedMedia = useSelector(get_selected_processedMedia);
    let mediaCache_list = useSelector(get_all_mediaCache);
    let mediaCache = useSelector(get_selected_mediaCache);
    let coherentScreen_list = useSelector(get_all_coherentScreen);
    let customerSettings = useSelector(get_selected_customerSettings)
    let customSettings_list = useSelector(get_all_customerSettings);
    let coherentScreen = useSelector(get_selected_coherentScreen);
    let curatedSeriesList_list = useSelector(get_all_curatedSeriesList);
    let curatedSeriesList = useSelector(get_selected_curatedSeriesList);
    let curatedMediaList_list = useSelector(get_all_curatedMediaList);
    let curatedMediaList = useSelector(get_selected_curatedMediaList);
    let season_list = useSelector(get_all_season);
    let season = useSelector(get_selected_season);
    let series_list = useSelector(get_all_series);
    let series = useSelector(get_selected_series);
    let media_list = useSelector(get_all_media);
    let media = useSelector(get_selected_media);
    let claims = useSelector(getUserClaims);
    let curated_list_busy = useSelector(is_curatedMediaList_busy);
    let curated_series_list_busy = useSelector(is_curatedSeriesList_busy);
    const [building, setBuilding] = useState(false);
    let apporved_media_busy = useSelector(is_approvedMedia_busy);
    const [asDefault, setAsDefault] = useState();
    const busy = building || curated_list_busy || curated_series_list_busy || apporved_media_busy;
    let dispatch = useDispatch();
    useEffect(() => {
        if (claims?.player) {
            dispatch(autoThunks.load_curated_series_list({
                ok: 'true'
            }))

            dispatch(autoThunks.load_curated_media_list({
                ok: 'true'
            }));
            dispatch(autoThunks.fetch_customer_settings({
                playerId: claims?.player
            }))
            dispatch(autoThunks.load_approved_media({
                ok: 'true'
            }))
            dispatch(autoThunks.load_processed_media({
                ok: 'true',
                playerId: claims?.player
            }))
            dispatch(autoThunks.load_approved_series({
                ok: 'true',
                playerId: claims?.player
            }))
        }

    }, [claims?.player])
    return (
        <>
            <Grid item xs={12}>
                <LinearIndeterminate visible={busy} />
            </Grid>
            <Grid item xs={3}>
                {busy ? <CircularIndeterminate /> : null}
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="coherentScreen-label">
                        {TitleService('Coherent Screen')}
                    </InputLabel>
                    <Select
                        labelId="coherentScreen-label"
                        id="coherentScreen-select"
                        value={params?.id}
                        label={TitleService('Coherent Screen')}
                        onChange={(val: any) => {
                            dispatch(
                                setSelectedcoherentScreen(val?.target?.value),
                            )
                            navigate(
                                ResolvePath(
                                    `/${getLocationPath()}/${val?.target?.value}`,
                                ),
                            )
                        }}
                    >
                        <MenuItem value="">
                            {TitleService('Select Content House')}
                        </MenuItem>
                        {(coherentScreen_list || []).filter(x => !x.owner).map((item) => {
                            return (
                                <MenuItem value={item.id} key={item.id}>
                                    {item.name}
                                </MenuItem>
                            )
                        })}
                    </Select>
                    <FormHelperText>
                        {TitleService('Select a coherent screen')}
                    </FormHelperText>
                </FormControl>
            </Grid>
            <Grid item xs={3}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="customer-selected">
                        {TitleService('Customers')}
                    </InputLabel>
                    <Select
                        labelId="customer-selected"
                        id="customer-selected"
                        value={customerSettings?.id || ''}
                        label={TitleService('Customers')}
                        onChange={(val: any) => {
                            dispatch(
                                setSelectedcustomerSettings(val?.target?.value),
                            )
                        }}
                    >
                        <MenuItem value="">
                            {TitleService('Default')}
                        </MenuItem>
                        {(customSettings_list || []).map((item) => {
                            return (
                                <MenuItem value={item.id} key={item.id}>
                                    {item.name}
                                </MenuItem>
                            )
                        })}
                    </Select>
                    <FormHelperText>
                        {TitleService('Select a customer')}
                    </FormHelperText>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Button disabled={busy} variant="outlined" onClick={async () => {
                    setBuilding(true)
                    let filter_curatedMediaList = curatedMediaList_list.filter(x => coherentScreen.orderedReferenceList.find(y => y === x.id));
                    let filtered_curatedSerieList = curatedSeriesList_list.filter(x => coherentScreen.orderedReferenceList.find(y => y === x.id));
                    let series_ids = [];
                    filtered_curatedSerieList.forEach(x => x.series.forEach(s => {
                        series_ids.push(s.id)
                    }));
                    let media_ids = [];
                    filter_curatedMediaList.filter(x => x?.media?.forEach).forEach((x) => x.media.forEach(m => {
                        media_ids.push(m.id);
                    }))
                    let quickLoadResource = {
                        series: series_list,
                        seriesId: series?.id,
                        media: trimDownMedias(media_list.filter(x => media_ids.includes(x.id))),
                        mediaId: media?.id,
                        seasonId: season?.id,
                        season: season_list.filter(season => series_ids.find(s => s.id === season.id)),
                        curatedSeriesListId: curatedSeriesList?.id,
                        curatedSeriesList: trimdownCuratedSeriesList(filtered_curatedSerieList),
                        curatedMediaListId: curatedMediaList?.id,
                        curatedMediaList: trimDownCuratedMediaList(filter_curatedMediaList),
                        approvedMediaId: approvedMedia?.id,
                        approvedSeries: trimDownApprovedSeries(approvedSeries_list),
                        approvedSeriesId: approvedSeries?.id,
                        processedMedia: trimDownProcessedMedias(processedMedia_list),
                        mediaCacheId: mediaCache?.id,
                        mediaCache: mediaCache_list,
                        processedMediaId: processedMedia?.id,
                        coherentScreen: coherentScreen_list.filter(x => x.id === coherentScreen.id),
                        coherentScreenId: coherentScreen?.id,
                        cachedUrls: {
                            ...firebaseapp.GetAllCachedUrls()
                        }
                    };
                    let categories = (await mapAsync<string, any>(coherentScreen.orderedReferenceList, (async (t: any, index: any, array: any): Promise<any> => {
                        let mediaList = curatedMediaList_list.find(x => x.id === t);
                        let seriesList = curatedMediaList_list.find(x => x.id === t);
                        if (mediaList) {
                            let processedMedias: any = mediaList.processedMedia;
                            if (!mediaList.processedMedia?.length) {
                                processedMedias = mediaList.media.map(t => quickLoadResource.processedMedia.find(pm => pm.media === t.id) as ProcessedMedia)
                            }
                            let mediaInformation = (processedMedias).filter(x => x).map((processedMedia) => {
                                processedMedia = JSON.parse(JSON.stringify(processedMedia));
                                let mediaItem = mediaList.media.find(v => v.id === processedMedia.media);
                                if (mediaItem) {
                                    let approvedMediaItem = approvedMedia_list.find(v => v.mediaId === processedMedia.media);
                                    if (approvedMediaItem?.hidden) {
                                        return null;
                                    }
                                    processedMedia.name = mediaItem.name;
                                    processedMedia.rating = mediaItem.rating;
                                    processedMedia.duration = mediaItem.mediaDuration;
                                    processedMedia.description = mediaItem?.description?.descriptionDefault || processedMedia.description;
                                    return processedMedia
                                }
                                return null;
                            }).filter(x => x)

                            let categoryList = {
                                listId: t,
                                name: mediaList.name,
                                media: await mapAsync(mediaInformation, (async (mt: any) => {
                                    if (mt?.states) {
                                        await mapAsync(mt.states, (async (state: any) => {
                                            let loc = state.location || state.mediaRel;
                                            if (!quickLoadResource.cachedUrls[loc]) {
                                                quickLoadResource.cachedUrls[loc] = await firebaseapp.ResolveStorageUrl(loc);
                                            }
                                            state.url = quickLoadResource.cachedUrls[loc];
                                            delete state.deleted;
                                            delete state.updated
                                            delete state.created
                                            delete state.ignore
                                            delete state.name
                                            delete state.version
                                            delete state.owner
                                            delete state.mediaId
                                            delete state.sourceLocation
                                            delete state.id
                                            delete state.sourceUrl
                                            delete state.location
                                        }));
                                    }
                                    return mt;
                                }))
                            };
                            return categoryList;
                        }
                    }))).filter(x => x)
                    const carrierContent: ContentCarrier = {
                        description: coherentScreen.name || 'Default Screen',
                        media: {
                            categories
                        }
                    }
                    await dispatch(autoThunks.store_content_carrier({
                        playerId: claims?.player,
                        carrierContent,
                        domain: customerSettings?.domain || ''
                    }))
                    setBuilding(false)
                    // await dispatch(autoThunks.store_start_up_cache({
                    //     playerId: claims?.player,
                    //     cache: JSON.stringify(quickLoadResource)
                    // }));
                    //     let generated_code = `
                    // tempState2 = { };
                    // `;
                    //     for (let i in quickLoadResource) {
                    //         generated_code += `tempState2.${i} = ${JSON.stringify(quickLoadResource[i])};\n`
                    //     }
                    //     console.log(generated_code);
                }}>
                    {TitleService('Publish')} {busy ? <FlashingText><CheckCircleIcon sx={{ color: 'success.dark', width: 14, height: 14 }} /></FlashingText>
                        : null}
                </Button>
            </Grid >
        </>
    )
}